// extracted by mini-css-extract-plugin
export default {"overflowBox":"FieldTableContainer_overflowBox__9bD0k","container":"FieldTableContainer_container__93K9s","scrollableContainer":"FieldTableContainer_scrollableContainer__6D7yf"};